import React, { useEffect } from 'react'
import SiteLayout from 'components/SiteLayout'
import Head from 'components/Head'
import JobsIndex from 'components/JobsIndex'
import { usePageView } from 'hooks'
import { getStaticWrapper } from 'utils'
import greenhouse from 'lib/greenhouse'

const JobsPage = () => {
  usePageView()

  useEffect(() => {
    greenhouse.load()
  }, [])

  return (
    <SiteLayout background='#FFFFFF' hideBanner hideHeader hideSiteSubNavigation>
      <Head
        title='Jobs | Barstool Sports'
        description='Barstool Sports is a company that will drive the way media is created and consumed for years to come. Join us.'
        ogImage='https://chumley.barstoolsports.com/union/2020/08/04/careers.f867e390.jpg'
      />
      <JobsIndex />
    </SiteLayout>
  )
}

export const getStaticProps = getStaticWrapper()

export default JobsPage
